import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import Slider from "react-slick";
import CTAButton from "./CTAButton";

import "./AppPaymentBanner.css";

const AppPaymentBanner = () => {
    const data = useStaticQuery(graphql`
        query HomePageHeroBannerListQuery {
            mobileBannnerOne: file(relativePath: { eq: "hp-mob-banner1.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            desktopBannnerOne: file(relativePath: { eq: "hp-banner1.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
            mobileBannnerTwo: file(relativePath: { eq: "hp-mob-banner2.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            desktopBannnerTwo: file(relativePath: { eq: "hp-banner2.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
            mobileBannnerThree: file(
                relativePath: { eq: "hp-mob-banner3.png" }
            ) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            desktopBannnerThree: file(relativePath: { eq: "hp-banner3.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
        }
    `);

    const BannnerOneImgSrc = [
        data.desktopBannnerOne.childImageSharp.fluid,
        {
            ...data.mobileBannnerOne.childImageSharp.fluid,
            media: `(max-width: 600px)`,
        },
    ];

    const BannnerTwoImgSrc = [
        data.desktopBannnerTwo.childImageSharp.fluid,
        {
            ...data.mobileBannnerTwo.childImageSharp.fluid,
            media: `(max-width: 600px)`,
        },
    ];

    const BannnerThreeImgSrc = [
        data.desktopBannnerThree.childImageSharp.fluid,
        {
            ...data.mobileBannnerThree.childImageSharp.fluid,
            media: `(max-width: 600px)`,
        },
    ];

    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 7000,
        pauseOnHover: true,
    };
    return (
        <Slider {...settings}>
            <div className="hp-banner-image">
                <Img fluid={BannnerOneImgSrc} alt="" />
                <CTAButton />
            </div>

            <div className="hp-banner-image">
                <Img fluid={BannnerTwoImgSrc} alt="" />
                <CTAButton />
            </div>

            <div className="hp-banner-image">
                <Img fluid={BannnerThreeImgSrc} alt="" />
                <CTAButton />
            </div>
        </Slider>
    );
};

export default AppPaymentBanner;
